import TermsV20260601 from "components/Terms/v20260601";
import { useRef } from "react";
import { useRouter } from "src/hooks/useRouter";

const TermsV20260601Page: React.FC = () => {
    const { goLogin } = useRouter();
    const headerRef = useRef<HTMLDivElement>(null);
    return (
        <>
            {/* <HeaderContainer headerRef={headerRef}></HeaderContainer> */}
            <div>
                <div className="top">
                    {/* <a onClick={goLogin}>
            <div className="icon_fasoo main" />
          </a> */}
                </div>
            </div>
            {/* <div style={{ background: "#f5f7fa" }}> */}
            <div style={{ width: "90%", margin: "auto" }}>
                <TermsV20260601></TermsV20260601>
            </div>
            {/* </div> */}
        </>
    );
};

export default TermsV20260601Page;
